import { Titillium_Web } from 'next/font/google';

export const titillium = Titillium_Web({
  weight: '600',
  subsets: ['latin'],
});

export interface SpidEntityType {
  logo_uri?: string;
  entity_id: string;
  registry_link?: string;
  organization_name: string;
}

export const SpidGovEntities: Array<SpidEntityType> = [
  {
    entity_id: 'https://id.eht.eu',
    organization_name: 'EtnaHitech S.C.p.A.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-etnaid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fid.eht.eu?output=json',
  },
  {
    entity_id: 'https://id.lepida.it/idp/shibboleth',
    organization_name: 'Lepida S.p.A.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-lepidaid.svg',
    registry_link:
      'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fid.lepida.it%2Fidp%2Fshibboleth?output=json',
  },
  {
    entity_id: 'https://identity.infocert.it',
    organization_name: 'InfoCert S.p.A.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-infocertid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fidentity.infocert.it?output=json',
  },
  {
    entity_id: 'https://identity.sieltecloud.it',
    organization_name: 'Sielte S.p.A.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-sielteid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fidentity.sieltecloud.it?output=json',
  },
  {
    entity_id: 'https://idp.intesigroup.com',
    organization_name: 'Intesi Group S.p.A.',
    logo_uri:
      'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-intesigroupspid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fidp.intesigroup.com?output=json',
  },
  {
    entity_id: 'https://idp.namirialtsp.com/idp',
    organization_name: 'Namirial',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-namirialid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fidp.namirialtsp.com%2Fidp?output=json',
  },
  {
    entity_id: 'https://login.id.tim.it/affwebservices/public/saml2sso',
    organization_name: 'TI Trust Technologies srl',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-timid.svg',
    registry_link:
      'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Flogin.id.tim.it%2Faffwebservices%2Fpublic%2Fsaml2sso?output=json',
  },
  {
    entity_id: 'https://loginspid.aruba.it',
    organization_name: 'ArubaPEC S.p.A.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-arubaid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Floginspid.aruba.it?output=json',
  },
  {
    entity_id: 'https://loginspid.infocamere.it',
    organization_name: 'InfoCamere S.C.p.A.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-infocamereid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Floginspid.infocamere.it?output=json',
  },
  {
    entity_id: 'https://posteid.poste.it',
    organization_name: 'Poste Italiane SpA',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-posteid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fposteid.poste.it?output=json',
  },
  {
    entity_id: 'https://spid.register.it',
    organization_name: 'Register.it S.p.A.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-spiditalia.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fspid.register.it?output=json',
  },
  {
    entity_id: 'https://spid.teamsystem.com/idp',
    organization_name: 'TeamSystem s.p.a.',
    logo_uri: 'https://cdn.jsdelivr.net/gh/italia/spid-sp-access-button/src/production/img/spid-idp-teamsystemid.svg',
    registry_link: 'https://registry.spid.gov.it/entities-idp/https%3A%2F%2Fspid.teamsystem.com%2Fidp?output=json',
  },
];
